import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const MinimumSpanningTreeAndDijkstra = () => (
  <QPhototModuleSubtopic
    title="Minimum Spanning Tree: Prim's, Kruskal's - Dijkstra’s Shortest Path"
    videos={[
      "https://www.youtube.com/embed/ToACXUBwouc",
      "https://www.youtube.com/embed/dtvoe_Ixum4",
      "https://www.youtube.com/embed/gqI-Yyzb3Qo"
    ]}
    takeaways={[]}
    questions={[
      { text: "Find the shortest path from vertex G to every other vertex using Dijkstra's algorithm.",
        image:"/dsa_35.png"
       },
      { text: "Compute the shortest path from A to Z using Dijkstra Algorithm for the following graph.",
        image:"/dsa_36.png"
       },
      { text: "Using Kruskal's and Prim's algorithms, compute the Minimum Spanning Tree for the following graph.",
        image:"/dsa_37.png"
       },
      { text: "For the given graph perform the minimum edge weighted spanning tree construction.",
        image:"/dsa_38.png"
       },
      { text: "For the given weighted graph G=(V,E) find the minimum spanning tree using Prim's algorithm by stating all the steps of the algorithm.",
        image:"/dsa_39.png"
       },
      { text: "Using Dijkstra's Algorithm find the shortest distance for source vertex S to remaining vertices in the following graph.",
        image:"/dsa_40.png"
       },
      { text: "Discuss and demonstrate how Dijkstra's algorithm can be applied to the following scenario: Imagine you are a delivery driver in a city with 9 locations. The locations are connected by roads with different travel times. You need to deliver a package from location 'a' to location 'h' as quick as possible. Estimate the total time required to deliver the package. Note: The travel time between locations are shown in the graph below:",
        image:"/dsa_41.png"
       },
      { text: "Can Dijkstra's algorithm be applied for the following graph? If 'Yes' find the shortest path from the vertex 'A' to all the other vertices. If 'No', justify your answer. Describe the algorithm also.",
        image:"/dsa_42.png"
       },
      { text: "Use Kruskal's algorithm to extract the minimum spanning tree of the graph given below.",
        image:"/dsa_43.png"
       },
      { text: "What are the final costs and shortest paths if we run Dijkstra's starting on node 'A' with algorithm? Provide the details of constructing shortest paths.",
        image:"/dsa_44.png"
       },
      { text: "Construct a minimum spanning tree (MST) for the given graph using Prim's Algorithm. Show step by step process.",
        image:"/dsa_45.png"
       },
      { text: "Using Dijkstra's Algorithm, find the shortest distance from source vertex '5' to remaining vertices in the following graph step by step. Do mention the algorithm also.",
        image:"/dsa_46.png"
       },
      { text: "The cable company has to put down the cables which can connect all the six houses (A, B, C, D, E, F) and it wishes to minimize the cost of cabling. Use Prim's algorithm (using A as the source) to show in a step by step manner how this can be achieved. The resultant connections and the total cost should also be provided. The cost matrix for the houses is given below. A positive value in (i,j) cell represents a cabling cost between house i and house j, 0 means no cost and inf signifies no cabling can be done.",
        image:"/dsa_47.png"
       },
      { text: "State the Dijkstra's algorithm for finding the shortest path between nodes of a graph and show the steps while computing the shortest path from the source vertex (A) to all other vertices in the given below graph and write a pseudo code.",
        image:"/dsa_48.png"
       },
      { text: "Identify the differences between Kruskal's and Prim's in a tabular form. Construct MST using Kruskal's algorithm for the following graph.",
        image:"/dsa_49.png"
       },
      { text: "Consider a logistics manager tasked with optimizing transportation routes for a delivery company that operates in a city with a complex network of roads. Your goal is to minimize the distance for packages to reach their destinations by finding the shortest paths between all pairs of locations. The transportation route is represented as weighted directed graph given below. Find the minimum spanning tree using Prim's algorithm, between all pairs of locations, considering the varying distance, which helps company to delivery operation. Map (Graph) is represented as a adjacency matrix is given b",
        image:"/dsa_50.png"
       },
      { text: "Define spanning tree with example." }
    ]}
    exampleVideos={[]}
  />
);

export default MinimumSpanningTreeAndDijkstra;
